module.exports = __webpack_public_path__ + "img/no-image.0d2acaa6.jpg";